module.exports = __webpack_public_path__ + "static/media/instagram.ab793928.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/social-icons/instagram.svg
// module id = 179
// module chunks = 0